import * as angular from "angular";
import {IController} from "angular";

export class BringozRecurringTypeSelectComponent implements IController {
  type: any;
  isRequired: any;
  isDisabled: any;
  onChange: Function;

  recurringTypes: any = this.commonsConstants.recurringTypes;

  constructor(private commonsConstants) {
  }

  $onInit() {

  }
}


angular
  .module('bringoz.admin.commons')
  .component('bringozRecurringTypeSelect', {
    bindings: {
      type: '<',
      isRequired: '<?',
      isDisabled: '<?',
      onChange: '&'
    },
    templateUrl: 'app/modules/commons/components/bringoz-recurring-type-select/bringoz-recurring-type-select.html',
    controller: BringozRecurringTypeSelectComponent
  });
